export default {
  isLoadingSuggestions: false,
  suggestions: [],
  error: false
};
